var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.74683 3.13656C8.46526 2.75246 10.3597 3.16288 11.9995 4.54931C13.6394 3.16288 15.5338 2.75246 17.2522 3.13656C19.1421 3.55897 20.7498 4.92797 21.517 6.84554C23.0858 10.7669 21.0867 16.5044 12.3669 21.4038C12.1388 21.5319 11.8603 21.5319 11.6322 21.4038C2.91241 16.5044 0.913291 10.7669 2.48209 6.84554C3.24925 4.92797 4.85696 3.55897 6.74683 3.13656ZM3.87478 7.40271C2.74618 10.2238 3.86316 15.1889 11.9995 19.8868C20.1359 15.1889 21.2529 10.2238 20.1243 7.40271C19.5344 5.92812 18.3148 4.91107 16.925 4.60044C15.5541 4.29401 13.9479 4.66038 12.5343 6.09772C12.3933 6.24109 12.2006 6.32183 11.9995 6.32183C11.7985 6.32183 11.6058 6.24109 11.4648 6.09773C10.0512 4.66038 8.44499 4.294 7.07403 4.60044C5.68426 4.91107 4.46471 5.92812 3.87478 7.40271Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.4a7f6cbe7b0204ef91da37248754caaf.svg";
export { ForwardRef as ReactComponent };